import { Box } from '@mui/material'
import { styled } from '@mui/material/styles'

export const SearchContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  button: {
    height: '40px',
    margin: '0 12px',
  },

  '& .MuiFormControl-root': {
    width: '100%',
    // border: '1px solid red', TODO: fix highlight issue

    '.MuiInputBase-formControl': {
      borderRadius: '4px 4px 0px 0px',

      fieldset: {
        border: '1px solid #B0B7C3',
      },
    },

    '.input-props': {
      padding: '8.5px 10px',
      fontSize: '14px',
      lineHeight: '18px',
      letterSpacing: '0.15px',
      fontWeight: '400',
      color: theme.palette.primary.main,
    },

    input: {
      borderBottomRightRadius: '0px',
      '&::placeholder': {
        color: theme.palette.grey[500], // theme.GREY
      },
    },
  },

  '& .icon-container': {
    display: 'flex',
    width: '40px',
    height: '40px',
    borderRadius: theme.shape.customBorderRadius.main,
    backgroundColor: theme.palette.primary.light,
    color: theme.palette.primary.main,
    cursor: 'pointer',
    zIndex: '2',

    svg: {
      margin: 'auto',
    },
  },
}))

export const InputWrapper = styled('div')({
  position: 'relative',
  width: '370px',
})

export const SearchAreaWrapper = styled('div')({
  display: 'flex',
  transition: 'all .5s ease',
})
